import { requestGQL } from 'common/graphQlClient';
import { gql } from 'graphql-request';

export const DELETE_BUNDLE = gql`
  mutation deleteBundle($input: DeleteNodeInput!) {
    deleteBundle(input: $input)
  }
`;

export const deleteBundle = (propertyId: number) => (nodeId: string) => {
  return requestGQL(DELETE_BUNDLE, { input: { propertyId, nodeId } });
};
